// extracted by mini-css-extract-plugin
export default {"canvas":"HeroNetwork_canvas__D6lJk","networkIn":"HeroNetwork_networkIn__Pl4Ot"};